import autosize from "autosize";
import type { Action } from "svelte/action";

export interface AutosizeSettings {
	/** @default true */
	enabled: boolean;
}

// Handles toggling display: none case.
let observer: ResizeObserver;

if (typeof ResizeObserver !== "undefined") {
	observer = new ResizeObserver((entries) => {
		autosize.update(entries.map(({ target }) => target));
	});
}

export const updateTextareaHeight: Action<HTMLElement, AutosizeSettings | undefined> = (node, settings) => {
	let enabled = false;

	if (settings?.enabled ?? true) {
		autosize(node);
		enabled = true;
		autosize.update(node);
	}

	observer.observe(node);

	return {
		update(settings): void {
			if (settings?.enabled ?? true) {
				if (enabled) {
					autosize.update(node);
				} else {
					autosize(node);
					enabled = true;
				}
			} else {
				autosize.destroy(node);
				enabled = false;
			}
		},
		destroy(): void {
			observer.unobserve(node);
			autosize.destroy(node);
			enabled = false;
		},
	};
};
